/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Kpis/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Kpis({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Kpis",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Kpis.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1Sw1JI': alignSelf,'--mt-2-1Sw1JI': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1Sw1JI': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1Sw1JI': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1Sw1JI': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1Sw1JI': opacity,'--w-10-1Sw1JI': typeof width === 'number' ? `${width}px` : width,'--h-11-1Sw1JI': typeof height === 'number' ? `${height}px` : height,'--f-12-1Sw1JI': fill,'--a-7-1Sw1JI': isAnimated ? animation : "none",'--sd-8-1Sw1JI': isAnimated ? strokeDashoffset : 0,'--sd-9-1Sw1JI': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Kpis.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M15.013 2.445a1.518 1.518 0 012.147 0l4.395 4.395a1.518 1.518 0 010 2.147L8.987 21.555a1.518 1.518 0 01-2.147 0L2.445 17.16a1.518 1.518 0 010-2.147l2.081-2.082 1.986 1.986a.893.893 0 101.262-1.263L5.79 11.668 8.098 9.36l1.985 1.985a.893.893 0 101.263-1.263L9.36 8.097l2.31-2.309 1.985 1.986a.893.893 0 101.262-1.263l-1.985-1.985 2.08-2.081z"
 style={{'--f-12-1Sw1JI': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}